import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { heroChecklist } from '../data/content';
import { CheckItem } from './CheckItem';
import { ProductImage } from './ProductImage';
export function ProductIntro() {
  return <section className="bg-white px-4 py-6 text-center md:px-12 md:py-7" data-id="element-110" data-mp="1nppcicqruodv">
      <h2 className="mx-auto max-w-[620px] font-heading text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] text-navy md:text-[24px]" data-id="element-111" data-mp="1smfvb7tyny2z">
        The complete 4-in-1 activity system for pediatric speech therapy
      </h2>
      <p className="mt-1.5 font-heading text-[23px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-brand md:text-[32px]" data-id="element-112" data-mp="2lb4u307jnrbk">
        <MessageCircleIcon className="mr-2 inline h-6 w-6 -translate-y-1 text-gold md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-113" data-mp="2bltsdymzloxp" />
        Complete Speech Therapy Activities Bundle™
      </p>
      <p className="mt-1.5 font-heading text-[11px] font-bold uppercase leading-tight tracking-[0.12em] text-goldDark md:text-[12px]" data-id="element-114" data-mp="342e7hkkfr08f">
        Ready-to-use activities for pediatric speech therapy
      </p>
      <p className="mt-1 text-[13px] leading-[1.35] text-ink md:text-[14px]" data-id="element-115" data-mp="pgu71rz40xy0">
        Articulation • Receptive Language • Expressive Language • Social Communication
      </p>

      <div className="mx-auto mt-3 max-w-[240px]" data-id="element-116" data-mp="147b8hbbqvnuw">
        <ProductImage data-id="element-117" data-mp="zdqj27o7w27b" />
      </div>

      <ul className="mt-3 grid gap-x-6 gap-y-1 text-left text-[14px] leading-[1.35] text-ink md:grid-cols-2 md:text-[15px]" data-id="element-118" data-mp="zcov52m3rl86">
        {heroChecklist.map(item => <CheckItem key={item} data-id="element-119" data-mp="1861zd0pma99k">{item.replace(/\.$/, '')}</CheckItem>)}
      </ul>
    </section>;
}